import React from 'react';
import RenderImg from '@/pages/opinion/components/RenderImg';
import './index.scss';
import { DefaultImg } from '@op/constants/defaultImg';
import { DBO_TM, DBO_V } from '@op/utils/format';
import { LanguageType } from '@op/types/common';
import { DBOM_CONTENT } from '@opm/utils';
import ChannelLabel from '@op/components/ChannelLabel';
import moment from 'moment';
import URLShare from '@opm/components/URLShare';

type THideKeys = "views" | "likes" | "comments" | "duration"

export default function videoCard({
  item,
  language = 'origin',
  hideKeys = ["comments"],
}: {
  item: any;
  language?: LanguageType;
  hideKeys?: THideKeys[];
}) {
  return (
    <div className="dbom-video-card">
      {/* 视频缩略图区域 */}
      <div className="dbom-video-thumbnail">
        <div className="dbom-video-thumbnail-img">
          <RenderImg
            className="dbom-video-thumbnail-cover"
            defaultImage={DefaultImg.VIDEO}
            coverImage={item.cover}
          />
        </div>
      </div>
      {/* 互动数据 - 左上角 */}
      <div className="dbom-video-stats">
        {
          hideKeys?.includes('views') ? null : (
            <div className="dbom-video-stats-item">
              <span className="dbom-stat-icon --playNum"></span>
              <span>{DBO_V.reviews(item.views)}</span>
            </div>
          )
        }
        {hideKeys?.includes('likes') ? null : (
          <div className="dbom-video-stats-item">
            <span className="dbom-stat-icon  --likes"></span>
            <span>{DBO_V.reviews(item.likes)}</span>
          </div>
        )}
        {hideKeys?.includes('comments') ? null : (
          <div className="dbom-video-stats-item">
            <span className="dbom-stat-icon  --comment"></span>
            <span>{DBO_V.reviews(item.comments)}</span>
          </div>
        )}
        {hideKeys?.includes('duration') ? null : (
          <div className="dbom-video-stats-item">
            <span className="dbom-stat-icon --duration"></span>
            <span>{DBO_TM.duration(item.duration, '-')}</span>
          </div>
        )}
      </div>
      {/* 视频信息区域 */}
      <div className="dbom-video-info">
        <ChannelLabel
          className="dbom-video-info-username"
          channel_name={item.channel}
          replaceText={item.username}
        ></ChannelLabel>

        {
          item?.time && (
            <div className="dbom-video-info-date">
              {moment(item.time).format('YYYY-MM-DD HH:mm')}
            </div>
          )
        }
        <div className="dbom-video-info-hashtags">
          {DBOM_CONTENT.videoTitle(language, item)}
        </div>
      </div>
      {/* <span className="dbom-video-share" onClick={() => DBO_U.open(item.url)}>
        <SvgIcon type="other-share-icon" className="dbom-video-svg" />
      </span> */}
      <URLShare
        url={item.url}
        className="dbom-video-share"
        iconClassName="dbom-video-svg"
      />
    </div>
  );
}
